import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-second-director-thank-you-application',
  templateUrl: './second-director-thank-you-application.component.html',
  styleUrls: ['./second-director-thank-you-application.component.scss']
})
export class SecondDirectorThankYouApplicationComponent implements OnInit {
product:string
  constructor(private router: Router) { }

  ngOnInit() {
    var locStorage=JSON.parse(localStorage.getItem("URLParam"))
      this.product=locStorage.ProductDescription
  }

}
